var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.04568 11.1959C5.01551 11.4598 5 11.7281 5 12C5 13.8004 5.67967 15.442 6.79641 16.6823L8.43025 14.7216L7.5138 11.9011L5.04568 11.1959ZM5.55587 9.26166L7.71363 9.87816L11 7.49047V5.07089C8.54247 5.42241 6.49671 7.05039 5.55587 9.26166ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM13 5.07089V7.49047L16.2864 9.87816L18.4441 9.26166C17.5033 7.05039 15.4575 5.42241 13 5.07089ZM18.9543 11.1959L16.4862 11.9011L15.5697 14.7216L17.2036 16.6823C18.3203 15.442 19 13.8004 19 12C19 11.7281 18.9845 11.4598 18.9543 11.1959ZM15.6677 17.9633L14.2283 16.2361H9.77165L8.33226 17.9633C9.39885 18.6207 10.6551 19 12 19C13.3449 19 14.6012 18.6207 15.6677 17.9633ZM9.37134 11.1459L10.3754 14.2361H13.6246L14.6287 11.1459L12 9.23607L9.37134 11.1459Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall);
export default __webpack_public_path__ + "static/media/Ball.0edbaa98.svg";
export { ForwardRef as ReactComponent };